export default __webpack_public_path__ + "static/media/Bitmap_3.db1cb4a8.jpg";